import { Component, Input, Output, EventEmitter, ElementRef, OnInit } from '@angular/core';
import { map, catchError } from 'rxjs/operators';
import { Validators, FormControl, FormGroup } from '@angular/forms';
import { Router ,ActivatedRoute} from '@angular/router';
import { KEY_CONFIG } from './../../../../lib/ng2-sapmp/src/config/key-config';
import { UtilityService } from './../../../../lib/ng2-sapmp/src/providers';
import { GridSortService } from './../../../../lib/ng2-sapmp/src/ui-components';
import { PageLoaderService } from 'lib/ng2-sapmp/src/ui-components/page-loader';
import { SendSMSService } from './../send-sms.service';
import { ENV } from 'config';

declare var ENV_VAR: any;

@Component({
  selector: 'app-message-modal',
  templateUrl: './message-modal.component.html',
  styleUrls: ['./message-modal.component.scss'],
  providers: [SendSMSService, GridSortService]
})

export class MessageModalComponent implements OnInit {

  public showError: boolean;
  public focusAbleElements: any;
  public pageJson: any;
  public messageForm: FormGroup;

  @Input() triggerElement: any;
  @Input() ctnDetails: any;
  @Output() modalOutput: EventEmitter<boolean>;

  constructor(private pageloaderService: PageLoaderService,
    private util: UtilityService,
    private el: ElementRef,
    private activatedRoute: ActivatedRoute,
    private router:Router,
    private messageService: SendSMSService) {
    this.messageForm = new FormGroup({
      text: new FormControl('', Validators.maxLength(140))
    });
    this.modalOutput = new EventEmitter<boolean>();
//messageService.fetchJSON(this.util.getEnvConfig().contentUrl.sendSMS.modal).subscribe(resObj1 => {
        this.pageJson  =  this.activatedRoute.snapshot.data.pageData.manageInventoryctnInfo.Modal;
  
  }
  ngOnInit() {
    document.body.classList.add('modal-open');
  }

  next(messageText, event?) {
        if (!event || event.keyCode === KEY_CONFIG.enter || event.keyCode === KEY_CONFIG.space) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
    const postBody = {
      message: messageText,
      ctnList: [this.ctnDetails.ctn],
      fanList: [this.ctnDetails.fan],
      accountType: 'ctnInfo'
    };
    const impersonator = JSON.parse(sessionStorage.getItem('impersonator'));
    const isDisabled = impersonator && impersonator.id ? true : false;
    if (isDisabled) {
      (<HTMLInputElement>document.getElementById('message-modal-btn')).disabled = true;
    } else {
      this.pageloaderService.setPageLoaderStatus(false);
      this.messageService.postSMS(postBody, this.ctnDetails).subscribe(success => {
         sessionStorage.setItem('smsSent', 'true');
        this.dimissModal(false);
      }, (err) => {
        this.pageloaderService.setPageLoaderStatus(true);
         this.showError = true;
        this.pageJson.cta.next = 'Retry';
      });
    }
  }
  }

  dimissModal(value, event?) {
    this.pageloaderService.setPageLoaderStatus(true);
    if (!event || event.keyCode === KEY_CONFIG.enter || event.keyCode === KEY_CONFIG.space) {
      if (event) {
        event.preventDefault();
        event.stopPropagation();
      }
      document.body.classList.remove('modal-open');
      // this.modalOutput.emit(value);
      this.focusAbleElements = undefined;
      if (this.triggerElement) {
        this.triggerElement.focus();
      }
      this.modalOutput.emit(value);
    }
  }

  loadFocusTelements() {
    if (!this.focusAbleElements) {
      const focusAbleEls = this.util.getFocusableElements(this.el);
      this.focusAbleElements = Array.prototype.slice.call(focusAbleEls);
      // this.focusabbleElements[0].focus();
      if(document.getElementById('modalHeading') != null){
        document.getElementById('modalHeading').focus();
      } 
    }
  }

  handleKeydown(event) {
    if (event.keyCode === KEY_CONFIG.escapeKey) {
      this.dimissModal(false);
      return;
    }
    this.util.handleKeyPress(event, this.focusAbleElements);
  }

}
